import React from "react";

import { IUnitType } from "shared/types";
import { useUnitType, WeightUnits } from "shared/utils";

import { Weight as WeightComponent } from "../components/Weight";

interface WeightProps {
  weight: number;
}

export const Weight: React.FC<WeightProps> = ({ weight }) => {
  const { unitType } = useUnitType();

  return (
    <WeightComponent
      weight={weight}
      toUnit={unitType === IUnitType.metric ? WeightUnits.kg : WeightUnits.lbs}
    />
  );
};
